import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { ChampDto, CriteresChampDtoInput, MutationGetListeChampsGeneriqueArgs } from 'src/graphql/generated-types';

@Injectable({
    providedIn: 'root'
})
export class GenericFieldsService {

    constructor(private readonly graphQlService: GraphqlService) {
    }

    getGenericFieldsList$(criteria: CriteresChampDtoInput): Observable<ChampDto[]> {
        return this.graphQlService.mutateOne<'GetListeChampsGenerique', MutationGetListeChampsGeneriqueArgs>({
            mutation: gql`
                mutation GetListeChampsGenerique(
                    $contexte: ContextInfosInput
                    $critere: CriteresChampDTOInput
                ) {
                    GetListeChampsGenerique(
                        contexte: $contexte
                        critere: $critere
                    ) {
                        ChampDTO {
                            MustValidate
                            MyGuid
                            Status

                            ChampTypeDonnee {
                                MustValidate
                                MyGuid
                                Status
                                Code
                                Id
                                Libelle
                            }
                            CEQfPerso {
                                Id
                                AbatPourc
                                DivCoef
                                DivNbPart
                                IdcAbatMntNbPart
                                IdcAddAlloc
                                IdcAddComplFam
                                IdcDiv12
                                IdcSousImpot
                                MntAbattement
                                TypeArrondi
                                ChampNbPartDiv {
                                    Id
                                    Libelle
                                    Code
                                }
                                ChampNbPartAbat {
                                    Id
                                    Libelle
                                    Code
                                }
                            }
                            CSNbPart {
                                Id
                                IdcPartODFix
                                MntPartODFix
                                MntPartConjointFix
                                ListePartODConjoint {
                                    PartsODConjointDTO {
                                        ChampListeValeur {
                                            Id
                                        }
                                        MyGuid
                                        CsNbPart_OD_PartSansEnf
                                        CsNbPart_OD_PartAvecEnf
                                        CsNbPart_Conjoint_PartSansEnf
                                        CsNbPart_Conjoint_PartAvecEnf
                                    }
                                }
                                IdcEnfantRattache
                                IdcPartEnfantFix
                                MntPartEnfantFix
                                ListePartEnfant {
                                    BorneDTO {
                                        Id
                                        BorneMin
                                        BorneMax
                                        BorneMontantFixe
                                        BornePourcentageFixe
                                    }
                                }
                                MntPartEnfantHandicape
                                PartEnfantMax
                                PartFamilleMax
                            }
                            Code
                            Description
                            Id
                            IsActivite
                            IsAfficheDirecto
                            IsAppliquerSurArticle
                            IsAppliquerSurFamille
                            IsAppliquerSurProduit
                            IsAyantDroit
                            IsCalculDynamique
                            IsChampPerso
                            IsCritereSociaux
                            IsMembre
                            IsParametre
                            IsParametreActivite
                            IsParametreAdmin
                            IsParametreCEParCE
                            IsParametreDirecto
                            IsParametreGestion
                            IsParametreGlobal
                            IsParametreUserParUser
                            IsRegleAccesibiliter
                            IsRegleQuota
                            IsRegleSubvention
                            Libelle
                            ListChampListeValeur {
                                ChampListeValeurDTO {
                                    MustValidate
                                    MyGuid
                                    Status
                                    ChaineSqlMoteur
                                    Code
                                    Id
                                    IsCloture
                                    OrdreAffichage
                                    Valeur
                                }
                            }
                            Ordre
                            ValeurParDefautParametre
                            ValeurChpListValParDefautParametre{
                                Id
                            }
                            UseHisto
                        }
                    }
                }
            `,
            variables: {
                critere: criteria
            }
        }).pipe(
            map(GetListeChampsGenerique => GetListeChampsGenerique?.ChampDTO || [])
        );
    }

}
